// Turn a params object into a clean querystring, dropping empty/null/undefined values.
export const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length) search.set(key, value.join(','));
    } else {
      search.set(key, value);
    }
  });
  const str = search.toString();
  return str ? `?${str}` : '';
};

// Strip empties from a params object (used before dispatching list thunks).
// Keys starting with `_` are internal (e.g. the `_r` refresh signal) and never sent to the backend.
export const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([k, v]) => !k.startsWith('_') && v !== undefined && v !== null && v !== '' && !(Array.isArray(v) && !v.length),
    ),
  );
